import { createActions } from 'redux-actions';

import types from 'state/direct-order-recurring/shipments/actionTypes';

const { directOrderRecurring } = createActions({
  // [types.CHANGE_VALUES]: (values, shipmentKey = 0) => ({ values, shipmentKey }),
  [types.SET_SHIPMENT_KEYS]: ({ shipmentKeys }) => ({
    shipmentKeys,
  }),

  [types.changeTime$]: ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay = 0,
  }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay,
  }),

  [types.selectTime$]: ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay = 0,
  }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay,
  }),

  [types.onBlurTimePicker$]: ({ stopType, timeParam, value, shipmentKey }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
  }),

  [types.changeDate$]: ({ stopType, value, shipmentKey }) => ({
    stopType,
    value,
    shipmentKey,
  }),

  [types.changeAddress$]: ({ stopType, shipmentKey, address }) => ({
    stopType,
    shipmentKey,
    address,
  }),

  [types.cleanAddress$]: ({ shipmentKey, stopType }) => ({
    shipmentKey,
    stopType,
  }),
});

export default directOrderRecurring;
